export const pagesPreview = [
    {
        image: "/images/websitePerformanceDis.png",
        title: "growth.websiteanalysis.preview.websitePerformance.title",
        descriptions: [
            "growth.websiteanalysis.preview.websitePerformance.subtitle1",
            "growth.websiteanalysis.preview.websitePerformance.subtitle2",
            "growth.websiteanalysis.preview.websitePerformance.subtitle3",
        ],
        textButton: "growth.websiteanalysis.preview.websitePerformance.button",
        navigationState: "digitalsuite_website_websiteperformance",
        pageName: "website performance",
    },
    {
        image: "/images/trafficAndEngagementDis.png",
        title: "growth.websiteanalysis.preview.trafficAndEngagement.title",
        descriptions: [
            "growth.websiteanalysis.preview.trafficAndEngagement.subtitle1",
            "growth.websiteanalysis.preview.trafficAndEngagement.subtitle2",
            "growth.websiteanalysis.preview.trafficAndEngagement.subtitle3",
        ],
        textButton: "growth.websiteanalysis.preview.trafficAndEngagement.button",
        navigationState: "digitalsuite_website_trafficandengagement",
        pageName: "traffic and engagement",
    },
    {
        image: "/images/marketingChannelsDis.png",
        title: "growth.websiteanalysis.preview.marketingChannels.title",
        descriptions: [
            "growth.websiteanalysis.preview.marketingChannels.subtitle1",
            "growth.websiteanalysis.preview.marketingChannels.subtitle2",
            "growth.websiteanalysis.preview.marketingChannels.subtitle3",
        ],
        textButton: "growth.websiteanalysis.preview.marketingChannels.button",
        navigationState: "digitalsuite_website_marketingchannels",
        pageName: "marketing channels",
    },
];
